import { render, staticRenderFns } from "./promotionman.vue?vue&type=template&id=5aa642a2&scoped=true&"
import script from "./promotionman.vue?vue&type=script&lang=js&"
export * from "./promotionman.vue?vue&type=script&lang=js&"
import style0 from "./promotionman.vue?vue&type=style&index=0&id=5aa642a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa642a2",
  null
  
)

export default component.exports